import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal } from "reactstrap"

/* HELPERS */
import { OFFER_DEDUCT } from '../../../config';
import { convertToRupiah } from '../../../utils';

/* ASSETS */
import CloseButton from "../../../images/close30.png"

export const HowDoesOfferWorks = ({
  isOpen,
  onToggle
}) => {
  const offerDeduct = convertToRupiah((parseFloat(OFFER_DEDUCT)));
  return (
    <Modal id="how-does-offer-works-info-modal" isOpen={isOpen} toggle={() => onToggle()}>
      <KickImage className="close-btn" src={CloseButton} alt="..." onClick={() => onToggle()} />
      <div className="hdow-info-wrapper">
        <div className="hdow-info-content">
          <p>How does offer work</p>
          <p>
            Make offers according to your budget. Your offer will be broadcasted to all relevant sellers,
            as soon as your <span>deposit</span> has been received.
          </p>
          <p>
            Once an offer has been accepted by a selller, you will be obligated to choose one of the
            following payment options:
          </p>
          <ol>
            <li>
              <p>Bank Transfer</p>
              <p>Make a transfer from your bank account, directly to our company’s bank account.</p>
            </li>
            <li>
              <p>Credit Card</p>
              <p>We can charge the offer amount to your credit card.</p>
            </li>
            <li>
              <p>Kick Credit</p>
              <p>We will reduce your balance by the amount offer amount.</p>
            </li>
          </ol>
        </div>
        <div className="tnc-content">
          <p>Terms and Conditions</p>
          <ol>
            <li>
              <p>You must have the full offer amount in available in your Kick Credit balance.</p>
            </li>
            <li>
              <p>Your kick credit will be deducted IDR. {offerDeduct},- which will be held as a DEPOSIT. This will be returned to you if your offer is accepted and you complete payment.</p>
            </li>
            <li>
              <p>If your offer is accepted and you do NOT complete payment, the DEPOSIT will not be returned and is claimed by our company.</p>
            </li>
            <li>
              <p>Only make offers with genuine intent to purchase. Failure to pay will flag your offer as a "hit and run" on our systems and your account may be suspended.</p>
            </li>
            <li>
              <p>You cannot make an offer that is higher than the listed price.</p>
            </li>
            <li>
              <p>Offer expires in 30 days. Maintain your offer list on your profile dashboard.</p>
            </li>
          </ol>
        </div>
      </div>
    </Modal>
  )
}

export const ShippingNReturnPolicy = ({
  isOpen,
  onToggle
}) => {
  return (
    <Modal id="shipping-n-return-policy" isOpen={isOpen} toggle={() => onToggle()}>
      <div className="shipping-n-policy-wrapper">
        <KickImage className="close-btn" src={CloseButton} alt="..." onClick={() => onToggle()} />
        <p>{`Shipping & Returns Policy`}</p>
        <div className="shipping-price">
          <p>We charge a flat-rate shipping. Every package includes bubble wrap and exterior boxing.</p>
          <p>Jakarta - IDR 40,000 </p>
          <p>Jawa - IDR 80,000 </p>
          <p>Outside Jawa - IDR 120,000 </p>
          <p>Papua - IDR 200,000/kg </p>
        </div>
        <div className="description-text">
          <p>
            We DO NOT accept returns on special items, vintages, samples {`(including friends and
          families)`}, aforementioned defected items or any pre-owned items. {`(Please make sure you
          have carefully inspect the conditions of the pre-owned should you choose to buy them)`}.
            There is limit of 2 days after you receive the items to request a return. Please contact our
            Customer Service at info@kickavenue.com or Whatsapp +6281210005425.
            Items must be in the condition they were in when sent by Kick Avenue, failure to meet this
            condition will result in rejection to claim your return.
          </p>
        </div>
      </div>
    </Modal>
  )
}